/* global grecaptcha */

import { BaseComponent } from "js/abstracts/baseComponent.js";
import { deferredImportScript, getGlobalSiteKey, STATUS } from "./library.js";

/**
 * Component for Google reCAPTCHA v2 with checkbox.
 */
export class reCaptchaV2Form extends BaseComponent {
    get Defaults() {
        return {
            fieldSelector: ".g-recaptcha-v2"
        };
    }

    /**
     * @param {HTMLFormElement} formElement
     * @param {Object} [options]
     */
    constructor(formElement, options) {
        super(options);
        this.formElement = formElement;

        // For v2, specifying the key in the URL is not allowed
        deferredImportScript("explicit").then(() => {
            this.setupForm();
        });

        this.on(document, "submit", event => {
            if (event.target === this.formElement && this.status === STATUS.FETCHED) {
                queueMicrotask(() => {
                    this.resetField();
                });
            }
        });
    }

    /**
     * Find the DOM element of the reCAPTCHA field.
     * @returns {HTMLDivElement}
     */
    getField() {
        return this.formElement.querySelector(this.options.fieldSelector);
    }

    /**
     * Reset the state of the reCAPTCHA field.
     */
    resetField() {
        const field = this.getField();
        if (field) {
            grecaptcha.reset(field.dataset.widgetId);
        }
    }

    /**
     * Get the public key for reCAPTCHA.
     * @returns {string}
     */
    getSiteKey() {
        const field = this.getField();
        return (field && field.dataset.sitekey) || getGlobalSiteKey();
    }

    /**
     * Initialize reCAPTCHA on the form.
     */
    setupForm() {
        const field = this.getField();
        const widgetID = grecaptcha.render(field, {
            sitekey: this.getSiteKey()
        });
        field.setAttribute("data-widget-id", widgetID);
    }
}
